import { render } from "./send-loa.vue?vue&type=template&id=406afced&scoped=true"
import script from "./send-loa.vue?vue&type=script&lang=js"
export * from "./send-loa.vue?vue&type=script&lang=js"

import "./send-loa.vue?vue&type=style&index=0&id=406afced&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-406afced"]])

export default __exports__